var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGenre = function SvgIconGenre(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M8 4.5a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2zM3 10a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M8 9a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2zM3 14.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M8 13.5a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2z"
  })));
};
export default SvgIconGenre;